import { useLexCounselStore } from '../../store/lexCounselStore';

export default function LexCounselInspector() {
  const messages = useLexCounselStore((s) => s.messages);
  const lastDiagnostics = useLexCounselStore((s) => s.lastDiagnostics);
  const cachedHearingBrief = useLexCounselStore((s) => s.cachedHearingBrief);
  const workspace = useLexCounselStore((s) => s.workspace);

  const lastAi = [...messages].reverse().find((m) => m.role === 'ai');
  const diag = lastAi?.diagnostics ?? lastDiagnostics;

  return (
    <div className="flex-1 min-h-0 overflow-y-auto px-4 py-3 space-y-4 text-[13px] text-[var(--counsel-text-body)]">
      <section>
        <h4 className="text-[11px] uppercase tracking-wider text-[var(--counsel-text-muted)] mb-2">Workspace</h4>
        <ul className="space-y-1 text-[var(--counsel-text-secondary)]">
          <li>Screen: {workspace.screen}</li>
          {workspace.caseId && <li>Case: {workspace.caseTitle ?? workspace.caseId}</li>}
          {workspace.draftTitle && <li>Draft: {workspace.draftTitle}</li>}
        </ul>
      </section>

      {lastAi?.sources && lastAi.sources.length > 0 && (
        <section>
          <h4 className="text-[11px] uppercase tracking-wider text-[var(--counsel-text-muted)] mb-2">Authorities used</h4>
          <ul className="space-y-1">
            {lastAi.sources.map((s, i) => (
              <li key={i} className="text-[var(--counsel-accent)]">
                {s.label || s.title}
              </li>
            ))}
          </ul>
        </section>
      )}

      {diag && (
        <section>
          <h4 className="text-[11px] uppercase tracking-wider text-[var(--counsel-text-muted)] mb-2">Diagnostics</h4>
          <ul className="space-y-1 text-[var(--counsel-text-secondary)] font-mono text-[12px]">
            {diag.reused_providers && (
              <li>Providers: {(diag.reused_providers as string[]).join(', ')}</li>
            )}
            {diag.orchestration_skills && (
              <li>Skills: {(diag.orchestration_skills as string[]).join(', ')}</li>
            )}
            {diag.retrieval_strategy && <li>Retrieval: {String(diag.retrieval_strategy)}</li>}
            {diag.overall_confidence != null && (
              <li>Confidence: {Number(diag.overall_confidence).toFixed(2)}</li>
            )}
            {diag.authority_count != null && <li>Authorities: {String(diag.authority_count)}</li>}
            {diag.generation_latency_ms != null && (
              <li>Latency: {Number(diag.generation_latency_ms).toFixed(0)}ms</li>
            )}
          </ul>
        </section>
      )}

      {cachedHearingBrief && (
        <section>
          <h4 className="text-[11px] uppercase tracking-wider text-[var(--counsel-text-muted)] mb-2">Cached hearing brief</h4>
          <p className="text-[var(--counsel-text-secondary)]">
            {String((cachedHearingBrief.summary as Record<string, unknown>)?.headline ?? 'Available')}
          </p>
        </section>
      )}

      {lastAi?.command && (
        <section>
          <h4 className="text-[11px] uppercase tracking-wider text-[var(--counsel-text-muted)] mb-2">Last command</h4>
          <p className="text-[var(--counsel-accent)]">/{lastAi.command}</p>
        </section>
      )}
    </div>
  );
}
